import { render } from "./ConfigureSamlSsoAuth.vue?vue&type=template&id=0beacfb6&scoped=true"
import script from "./ConfigureSamlSsoAuth.vue?vue&type=script&lang=js"
export * from "./ConfigureSamlSsoAuth.vue?vue&type=script&lang=js"

import "./ConfigureSamlSsoAuth.vue?vue&type=style&index=0&id=0beacfb6&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0beacfb6"]])

export default __exports__